import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _SortDropdown;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
var SortDropdown_1;
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { PlatformsSortEnum } from "@/store/enums/PlatformsSortEnum";
import { SortOrderEnum } from "@/store/enums/SortOrderEnum";
var SortDropdown = SortDropdown_1 = (_SortDropdown = /*#__PURE__*/function (_Vue) {
  function SortDropdown() {
    var _this;
    _classCallCheck(this, SortDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SortDropdown, [].concat(args));
    _defineProperty(_this, "placement", void 0);
    _defineProperty(_this, "items", []);
    _defineProperty(_this, "selectedItem", void 0);
    _defineProperty(_this, "dropdownIsOpened", void 0);
    return _this;
  }
  _inherits(SortDropdown, _Vue);
  return _createClass(SortDropdown, [{
    key: "mounted",
    value: function mounted() {
      this.items = this.buildSortItems();
      this.selectedItem = this.getSelectedItem();
    }
  }, {
    key: "getSelectedItem",
    value: function getSelectedItem() {
      var _this$items;
      var item = (_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.filter(function (item) {
        return item.isSelected;
      })[0];
      return item ? item : this.items[0];
    }
  }, {
    key: "onCommandHandled",
    value: function onCommandHandled(key) {
      var _this$selectedItem$ke;
      this.items.forEach(function (item) {
        return item.isSelected = item.key === key;
      });
      this.selectedItem = this.getSelectedItem();
      var sortKeySplitted = (_this$selectedItem$ke = this.selectedItem.key) === null || _this$selectedItem$ke === void 0 ? void 0 : _this$selectedItem$ke.split(SortDropdown_1.SORT_ORDER_SEPARATOR);
      if ((sortKeySplitted === null || sortKeySplitted === void 0 ? void 0 : sortKeySplitted.length) == 2) {
        var output = {
          sortBy: sortKeySplitted[0],
          sortOrder: sortKeySplitted[1]
        };
        this.$emit('onItemSelected', output);
      }
    }
  }, {
    key: "onVisibilityChanges",
    value: function onVisibilityChanges(isOpened) {
      this.dropdownIsOpened = isOpened;
    }
  }, {
    key: "buildSortItems",
    value: function buildSortItems() {
      return [{
        key: "".concat(PlatformsSortEnum.NAME).concat(SortDropdown_1.SORT_ORDER_SEPARATOR).concat(SortOrderEnum.ASC),
        value: this.$t("sort_dropdown.a_z").toString(),
        icon: 'sort-alphabetical-ascending',
        isSelected: true
      }, {
        key: "".concat(PlatformsSortEnum.NAME).concat(SortDropdown_1.SORT_ORDER_SEPARATOR).concat(SortOrderEnum.DESC),
        value: this.$t("sort_dropdown.z_a").toString(),
        icon: 'sort-alphabetical-descending'
      }, {
        key: "".concat(PlatformsSortEnum.CREATION_DATE).concat(SortDropdown_1.SORT_ORDER_SEPARATOR).concat(SortOrderEnum.ASC),
        value: this.$t("sort_dropdown.newest_first").toString(),
        icon: 'sort-clock-ascending-outline',
        divided: true
      }, {
        key: "".concat(PlatformsSortEnum.CREATION_DATE).concat(SortDropdown_1.SORT_ORDER_SEPARATOR).concat(SortOrderEnum.DESC),
        value: this.$t("sort_dropdown.oldest_first").toString(),
        icon: 'sort-clock-descending-outline'
      }];
    }
  }]);
}(Vue), _defineProperty(_SortDropdown, "SORT_ORDER_SEPARATOR", '-'), _SortDropdown);
__decorate([Prop({
  default: 'bottom'
})], SortDropdown.prototype, "placement", void 0);
SortDropdown = SortDropdown_1 = __decorate([Options({
  data: function data() {
    return {
      selectedItem: null,
      dropdownIsOpened: false
    };
  }
})], SortDropdown);
export default SortDropdown;